import { useEffect } from 'react'

import type { VersionService } from '../VersionService'

/**
 * Liga e desliga o polling de versão junto com o ciclo de vida do provider.
 *
 * O `dispose` importa: sem ele, uma remontagem deixaria o checker anterior
 * batendo no endpoint e o `IdleManager` anterior escutando eventos — dois
 * serviços concorrendo para recarregar a mesma página.
 */
export const useVersionPolling = (service: VersionService) => {
  useEffect(() => {
    service.start()

    return () => service.dispose()
  }, [service])
}
